import Table from "./Table";

export default function Pills({subscriptionPlans, infos, options, subscriptins, transactions,devise,setDevise,transactionType,setTransactionType, reference,setReference, charging, isLastPage, currentPage, setCurrentPage}){
    return(
        <div>
            <h6 className="text-muted">Options Supplementaires</h6>
            <div className="nav-align-top mb-4">
                <ul className="nav nav-pills mb-3 nav-fill" role="tablist">
                    <li className="nav-item">
                        <button
                            type="button"
                            className="nav-link active"
                            role="tab"
                            data-bs-toggle="tab"
                            data-bs-target="#navs-pills-justified-home"
                            aria-controls="navs-pills-justified-home"
                            aria-selected="true"
                        >
                            <i className="tf-icons bx bx-receipt"></i> Packs d'Abonnement
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className="nav-link"
                            role="tab"
                            data-bs-toggle="tab"
                            data-bs-target="#navs-pills-justified-messages"
                            aria-controls="navs-pills-justified-messages"
                            aria-selected="false"
                        >
                            <i className="tf-icons bx bx-grid"></i>Options d'Abonnement
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className="nav-link"
                            role="tab"
                            data-bs-toggle="tab"
                            data-bs-target="#navs-pills-justified-profile"
                            aria-controls="navs-pills-justified-profile"
                            aria-selected="false"
                        >
                            <i className="tf-icons bx bx-id-card"></i> Informations d'Abonnements
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className="nav-link"
                            role="tab"
                            data-bs-toggle="tab"
                            data-bs-target="#navs-pills-justified-statistics"
                            aria-controls="navs-pills-justified-statistics"
                            aria-selected="false"
                        >
                            <i className="tf-icons bx bx-purchase-tag-alt"></i>Liste des Souscriptions
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className="nav-link"
                            role="tab"
                            data-bs-toggle="tab"
                            data-bs-target="#navs-pills-justified-transactions"
                            aria-controls="navs-pills-justified-transactions"
                            aria-selected="false"
                        >
                            <i className="tf-icons bx bx-purchase-tag-alt"></i>Liste des Transactions
                        </button>
                    </li>
                </ul>
                <div className="tab-content">
                    <div className="tab-pane fade show active" id="navs-pills-justified-home" role="tabpanel">
                        <Table title={"Packs d'Abonnement"} content={subscriptionPlans} type={"subscriptionPlan"} setDevise={setDevise} devise={devise} setTransactionType={setTransactionType} transactionType={transactionType} reference={reference} setReference={setReference} charging={charging} currentPage={currentPage} setCurrentPage={setCurrentPage} isLastPage={isLastPage}/>
                    </div>
                    <div className="tab-pane fade" id="navs-pills-justified-messages" role="tabpanel">
                        <Table title={"Options d'Abonnement"} content={options} type={"options"} setDevise={setDevise} devise={devise} setTransactionType={setTransactionType} transactionType={transactionType} reference={reference} setReference={setReference} charging={charging} currentPage={currentPage} setCurrentPage={setCurrentPage} isLastPage={isLastPage}/>
                    </div>
                    <div className="tab-pane fade" id="navs-pills-justified-profile" role="tabpanel">
                        <Table title={"Informations d'Abonnements"} content={infos} type={"infos"} setDevise={setDevise} devise={devise} setTransactionType={setTransactionType} transactionType={transactionType} reference={reference} setReference={setReference} charging={charging} currentPage={currentPage} setCurrentPage={setCurrentPage} isLastPage={isLastPage}/>
                    </div>
                    <div className="tab-pane fade" id="navs-pills-justified-statistics" role="tabpanel">
                        <Table title={"Liste des Souscriptions"} content={subscriptins} type={"clientSubscription"} setDevise={setDevise} devise={devise} setTransactionType={setTransactionType} transactionType={transactionType} reference={reference} setReference={setReference} charging={charging} currentPage={currentPage} setCurrentPage={setCurrentPage} isLastPage={isLastPage}/>
                    </div>
                    <div className="tab-pane fade" id="navs-pills-justified-transactions" role="tabpanel">
                        <Table title={"Liste des transactions"} content={transactions} type={"transactions"} setDevise={setDevise} devise={devise} setTransactionType={setTransactionType} transactionType={transactionType} reference={reference} setReference={setReference} charging={charging} currentPage={currentPage} setCurrentPage={setCurrentPage} isLastPage={isLastPage}/>
                    </div>
                </div>
            </div>
        </div>
    );
}